import React from 'react';
import { Image } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './IconSelector.css';

let ListIcon;
let BlockIcon;

export const IconSelector = ({ listMode, onClickListMode }) => {
  if (listMode) {
    ListIcon = (
      <div className="icon-selected-container">
        <Image className="view-icon-selected" src="/icon/list-view.png" />
      </div>
    );
    BlockIcon = (
      <div className="icon-unselected-container">
        <Image
          className="view-icon-unselected"
          src="/icon/block-view.png"
          onClick={onClickListMode}
        />
      </div>
    );
  } else {
    ListIcon = (
      <div className="icon-unselected-container">
        <Image
          className="view-icon-unselected"
          src="/icon/list-view.png"
          onClick={onClickListMode}
        />
      </div>
    );
    BlockIcon = (
      <div className="icon-selected-container">
        <Image className="view-icon-selected" src="/icon/block-view.png" />
      </div>
    );
  }
  return (
    <div id="view-icon-selector">
      {ListIcon}
      {BlockIcon}
    </div>
  );
};

IconSelector.propTypes = {
  listMode: PropTypes.bool.isRequired,
  onClickListMode: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/views/IconSelector.js